import type { AnnouncementCard as AnnouncementCardType } from '@/cmsBackend/transformers/types/featureAnnouncement';
import { ImageBlock } from '@/components/blocks/ImageBlock';
import React from 'react';
import styles from './AnnouncementCard.module.scss';

export interface AnnouncementCardProps {
  card: AnnouncementCardType;
}

export const AnnouncementCard: React.FC<AnnouncementCardProps> = ({ card }) => {
  return (
    <article id={card.slug} className={styles.card}>
      <div className={styles.card__content}>
        <div className={styles.card__headingContainer}>
          <p className={styles.card__date}>{card.date}</p>
          <h3 className={styles.card__title}>{card.title}</h3>
        </div>
        <p className={styles.card__summary}>{card.summary}</p>
      </div>
      {card.media &&
        (card.media.type === 'video' ? (
          <video
            src={card.media.src}
            autoPlay
            muted
            loop
            playsInline
            className={styles.card__image}
            aria-label={card.media.alt}
          />
        ) : (
          <ImageBlock
            src={card.media.src}
            alt={card.media.alt}
            aspectRatio="standard"
            className={styles.card__image}
          />
        ))}
    </article>
  );
};
